import { StyledGridCol, StyledGridRow } from "@/common/styles";
import { Content } from "./style";
import Modal from "@/common/elements/Modal";
import TextField from "@/common/elements/InputElements/TextField";
import { useState } from "react";

const HouseandTracksClearPopup = ({
  show,
  setShow,
  bookingsFieldsEnabled,
  handleOk,
}) => {
  const [value, setValue] = useState("");
  const content = "Please enter the reason why you are clearing the housing: ";

  return (
    <Modal
      show={show}
      onHide={() => setShow(false)}
      size="md"
      footerActions={[
        {
          key: "ok",
          text: "Ok",
          onClick: () => {
            handleOk(value);
            setValue("");
          },
          disabled: !(bookingsFieldsEnabled && value),
        },
      ]}
      footerCloseAction
      footerCloseActionText="Cancel"
    >
      <Content>{content}</Content>
      <StyledGridRow>
        <StyledGridCol span={20}>
          <TextField
            value={value}
            onChange={(e) => {
              setValue(e.target.value);
            }}
            inputType="textarea"
            placeholder="Comments"
            variant="outlined"
          />
        </StyledGridCol>
      </StyledGridRow>
    </Modal>
  );
};

export default HouseandTracksClearPopup;
